export default {
  cake: {
    56: '0x50f4220C82c9325dC99f729C3328FB5c338BEaae',
    97: '0xADA2270B0CB5b6254d3d48A6fEE55b72693B746A',
  },
  masterChef: {
    56: '0x67905ff1Ada0C11720E7298840206E5bdB8d3646',
    97: '0xE37Aa693d2Ab77721E11e55bfBC723cf4457b78E',
  },
  wbnb: {
    56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    97: '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd',
  },
  lottery: {
    56: '',
    97: '',
  },
  lotteryNFT: {
    56: '',
    97: '',
  },
  mulltiCall: {
    56: '0x1ee38d535d541c55c9dae27b12edf090c608e6fb',
    97: '0x67ADCB4dF3931b0C5Da724058ADC2174a9844412',
  },
  busd: {
    56: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    97: '0xeD24FC36d5Ee211Ea25A80239Fb8C4Cfd80f12Ee',
  },
}